module.exports = "/_next/static/images/0b4b7480a3544a878eae7b443ad0608e-phone-and-card@sm-1x.jpg";